var React = require('react');

function Dj (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-40 0h682.7v512H-40z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(37.5) scale(.94)","key":1},[React.createElement("path",{"fill":"#0c0","d":"M-40 0h768v512H-40z","key":0}),React.createElement("path",{"fill":"#69f","d":"M-40 0h768v256H-40z","key":1}),React.createElement("path",{"fill":"#fffefe","d":"M-40 0l382.7 255.7L-40 511V0z","key":2}),React.createElement("path",{"fill":"red","d":"M119.8 292L89 270l-30.7 22.4L69.7 256l-30.6-22.5 37.9-.3 11.7-36.3 12 36.2h37.9l-30.5 22.7 11.7 36.4z","key":3})])]);
}

Dj.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Dj;

Dj.default = Dj;
